<template>
    <div class="mail-configure">
     <main>

        <a-row style="padding:0 20px;">
            <a-form-model :model="mailForm" ref="searchBar" :rules="mailFormRules" >
                <a-col :span="24">
                        <a-form-model-item prop="emailHost" label="邮箱服务器地址">
                            <a-input v-model="mailForm.emailHost" placeholder="请输入" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="24">
                    <a-form-model-item prop="emailPort" label="端口">
                            <a-input v-model="mailForm.emailPort" placeholder="请输入" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="24">
                        <a-form-model-item prop="emailUserName" label="发件箱">
                            <a-input v-model="mailForm.emailUserName" placeholder="请输入" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="24">
                    <a-form-model-item prop="emailPassWord" label="密码">
                            <a-input-password v-model="mailForm.emailPassWord" placeholder="请输入" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="24">
                    <a-form-model-item prop="emailName" label="发件箱用户名">
                            <a-input v-model="mailForm.emailName" placeholder="请输入" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="24">
                  <a-form-model-item prop="emailSsl" label="使用SSL">
                            <a-switch v-model="mailForm.emailSsl" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="24" class="sysSet-operate">
                    <a-form-model-item >
                        <a-button @click="sysSetVisible = true" v-if="$IA('system:setting:testEmail')">
                          测试邮箱设置
                        </a-button>
                        <a-button type="primary" @click="handleOk('searchBar')"  v-if="$IA('system:setting:update')"  :loading="submitLoad">
                         保存
                        </a-button>
                    </a-form-model-item>
                </a-col>
            </a-form-model>
       </a-row>

       <a-modal
          centered
          title="测试邮件设置" 
          :visible="sysSetVisible" 
          :confirm-loading="btnLoad"
          @ok="setEmil('testmailForm')" 
          @cancel="resetForm" 
          :maskClosable="false"
        >
        <a-form-model  layout="vertical" ref="testmailForm" :model="testmailForm"  :rules="testmailFormRules" >
            <a-form-model-item label="收件人" prop="sendEmail">
            <a-input v-model="testmailForm.sendEmail" placeholder="请输入" />
            </a-form-model-item>
        </a-form-model>
       </a-modal>

     </main>
    </div>
  </template>
  
  <script>
  import {notification} from "ant-design-vue";

  export default {
    data() {
      return {
        btnLoad: false,
        submitLoad: false,
        mailForm: {
          emailHost: '',
          emailPort: '',
          emailUserName: '',
          emailPassWord: '',
          emailName:'',
          emailSsl:false,
        },
        mailFormRules: {
           emailHost: [
            { required: true, message: '邮箱服务器地址不能为空' },
            { max: 100, message: '最长不能超过100字符'}
          ],
           emailPort: [
            { required: true, message: '端口不能为空' },
            {
              pattern:  /^[0-9]\d*$/,
              message: "端口格式不正确",
            },
            {max: 20, message: '最长不能超过20字符'}
          ],
           emailUserName: [
            { required: true, message: '发件箱不能为空' },
            {
              pattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
              message: "发件格式不正确",
            },
            {max: 250, message: '最长不能超过250字符'}
          ],
           emailPassWord: [
            { required: true, message: '密码不能为空' },
            { max: 250, message: '最长不能超过250字符' }
          ],
           emailName: [
            { required: true, message: '发件箱用户名请输入不能为空' },
            { max: 250, message: '最长不能超过250字符' }
          ],
          emailSsl: [
            { required: true, message: '使用SSL不能为空' },
          ],
        },

        // 测试邮件
        testmailForm:{
          sendEmail:""
        },
        testmailFormRules:{
          sendEmail:{
            pattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            message: "邮件格式不正确",
          },
        },
        sysSetVisible:false,
      };
    },
    methods: {
        // 重置表单通用方法
        resetForm() {
          this.$refs.testmailForm.resetFields()
          this.sysSetVisible = false
       },
      // 监听流程下拉框-选择机器人
      sysSetList() {
        this.axios
        .post("/setting/getEmailSetting")
          .then((res) => {
            if (res.code === 200) {
              this.mailForm = res.data
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
       // 邮件保存
       handleOk(formName){
        this.$refs[formName].validate((valid) => {
            if (valid) {
              this.submitLoad = true;
              let saveData = "";
              saveData = this.$lodash.cloneDeep(this.mailForm);
              saveData.emailPassWord = this.$encrypt.encrypt(saveData.emailPassWord)
              this.axios
                .post('/setting/updateEmailSetting', saveData)
                .then((res) => {
                  this.submitLoad = false;
                  if (res.code === 200) {
                    this.sysSetList()
                    notification.success({
                      message: res.message,
                      duration: 3,
                      customClass: "batch-import",
                    })
                  }
                })
                .catch((err) => {
                  this.submitLoad = false;
                  console.log(err);
                });
            } else {
              console.log("error submit!!");
              return false;
            }
          });
       },

       // 测试邮件发送
       setEmil() {
        this.btnLoad = true
        this.axios
        .post("/setting/testEmail",{sendEmail:this.testmailForm.sendEmail})
          .then((res) => {
            this.btnLoad = false
            // this.resetForm()
            if (res.code === 200) {
              notification.success({
                message: res.message,
                duration: 3,
                customClass: "batch-import",
              })
            }
          })
          .catch((err) => {
            this.btnLoad = false
            console.log(err);
          });
      },
    },
    beforeMount() {
      this.sysSetList();
  },
  };
  </script>
  
  <style lang="scss" scoped>
  .mail-configure{
    header {
      display: flex;
      align-items: flex-end;
      margin: -7px -8px 0;
      padding: 16px;
      letter-spacing: 1px;
      background-color: #fff;
  
      h3 {
        margin-bottom: 0;
        line-height: 20px;
        padding-left: 12px;
        border-left: 4px solid #3373f2;
        font-size: 18px;
        //font-weight: bold;
      }
  
      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }
  
    main {
      margin: 16px 0px;
      background-color: #fff;
    //   padding: 0 16px;
      box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1), 0 4px 5px 0 rgba(0, 0, 0, 0.07),
        0 1px 10px 0 rgba(0, 0, 0, 0.06);
      border-radius: 4px;
  
      .toolbar {
        display: flex;
        justify-content: space-between;
        padding: 16px 0;
      }
      .sysSet-title{
        display: flex;
        align-items: center;
        height: 55px;
        line-height: 55px;
        color: #3373f2;
        padding: 0 20px;
        border-bottom: 1px #c6c8cd solid;
        position: relative;
        h3{
            margin: 0px;
            //font-weight: 600;
            margin-left: 10px;
            color: #3373f2;
            font-size: 16px;
        }
        i{
            font-size: 18px;
        }
        .divider{
            position:absolute;
            display: inline-block;
            background-color: #3471fa;
            width: 60px;
            height: 2px;
            bottom: -1px;
        }
      }
      .ant-row{
        .ant-form{
            margin-top: 15px;
            ::v-deep .ant-form-item-required{
                color: #687c96;
            }
            .ant-input{
                border: none;
                padding: 0px;
                border-radius: 0px;
                border-bottom: 1px solid #d8d8d8;
            }
            .ant-input:focus,
            :hover {
                box-shadow: none;
                border-bottom-color: #40a9ff;
            }
            .has-error .ant-input, .has-error .ant-input:hover{
                border-color: #f5222d;
            }
            ::v-deep .ant-input-password   .ant-input:focus,
            :hover {
                box-shadow: none;
                border-bottom-color: #40a9ff;
            }
            ::v-deep .ant-input-password .has-error .ant-input, .has-error .ant-input:hover{
                border-color: #f5222d;
            }
            ::v-deep .ant-input-password .ant-input{
              border: none;
                padding: 0px;
                border-radius: 0px;
                border-bottom: 1px solid #d8d8d8;
            }
           ::v-deep .ant-form-item-label > label::after{
                margin: 0px;
                top:0px;
                content:none;
            }
            .sysSet-operate{
                text-align: right;
                margin-top: 35px;
                .ant-btn:nth-child(1){
                    margin-right: 15px;
                    background-color: #ecf0fe;
                    color: #3373f2;
                    letter-spacing: 1px;
                }
                .ant-btn:nth-child(2){
                    width: 70px;
                }
            }
        }
     
      }
    }
  }
  </style>
  